import React from 'react';

import { offset } from '@floating-ui/react';

import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useTooltipDialog } from 'hooks/useTooltipDialog/useTooltipDialog';

import cs from '../../../index.module.css';
import s from './index.module.css';

type Props = {
  disabled?: boolean;
  tooltipId: string;
  handleSaveForMyself: () => void;
  handleSaveForTeam: () => void;
  isImprovedUIOnEventModalsFeature?: boolean;
};

// Todo: Update file after complete improvedUIOnEventModalsFeature
function SaveInfoButton({
  disabled,
  handleSaveForMyself,
  handleSaveForTeam,
  tooltipId,
  isImprovedUIOnEventModalsFeature,
}: Props) {
  const { isMobile } = useMediaBreakpoints();

  const saveInfoTooltipDialog = useTooltipDialog({
    options: [
      { text: 'Myself', onClick: handleSaveForMyself, isFlex: true },
      { text: 'Whole Team', onClick: handleSaveForTeam, isFlex: true },
    ],
    message: (
      <Text size={isMobile ? 'medium' : 'small'} type="brandon" isStrong className={s.tooltipDialogMessageContainer}>
        I'd like to save this for...
      </Text>
    ),
    floatingOptions: { middleware: [offset(6)] },
    containerClassName: s.modalTooltipDialogContainer,
  });

  return (
    <React.Fragment>
      <div ref={saveInfoTooltipDialog.setReference}>
        <Button
          data-tip
          data-for={tooltipId}
          onClick={saveInfoTooltipDialog.openTooltip}
          disabled={disabled}
          type="default"
          className={cs.buttonText}
          size="large"
          htmlType="button"
        >
          {isImprovedUIOnEventModalsFeature ? 'Save for Future Use' : 'Save Info For Later'}
        </Button>
      </div>

      {saveInfoTooltipDialog.TooltipDialog()}
    </React.Fragment>
  );
}

export { SaveInfoButton };
export default SaveInfoButton;
